import request from '@/util/request'
import { encrypt, decrypt } from '@/util/crypto'

const state = {
  access_token: JSON.parse(sessionStorage.getItem('access_token')) || null,
  expires_in: JSON.parse(sessionStorage.getItem('expires_in')) || 15 * 60000,
  token_type: 'bearer',
  userID: JSON.parse(sessionStorage.getItem('userID')) || null,
  username: JSON.parse(sessionStorage.getItem('username')) || null,
  userRoleEnc: JSON.parse(sessionStorage.getItem('userRoleEnc')) || null,
  userKontora: JSON.parse(sessionStorage.getItem('userKontora')) || null,
  userKontoraTipas:
    JSON.parse(sessionStorage.getItem('userKontoraTipas')) || null,
  userSutartis: JSON.parse(sessionStorage.getItem('userSutartis')) || null,
  userSutikimas: JSON.parse(sessionStorage.getItem('userSutikimas')) || false,
  userSutikimasNtr:
    JSON.parse(sessionStorage.getItem('userSutikimasNtr')) || false,
  savitarnaSutartis:
    JSON.parse(sessionStorage.getItem('savitarnaSutartis')) || false,
  savitarnaXid: null,
  signNtrVadovas: JSON.parse(sessionStorage.getItem('signNtrVadovas')) || null,
  zinuteAktyvi: JSON.parse(sessionStorage.getItem('zinuteAktyvi')) || null,
  avatar: null,
  ipasasNative: JSON.parse(sessionStorage.getItem('ipasasNative')) || 0,
}
const getters = {
  getAccessToken: state => {
    return state.access_token
  },
  getExpiresIn: state => state.expires_in,
  getAvatar: state => state.avatar,
  getUsername: state => state.username,
  userID: state => state.userID,
  userKontora: state => state.userKontora,
  userKontoraTipas: state => state.userKontoraTipas,
  userSutartis: state => state.userSutartis,
  userSutikimas: state => state.userSutikimas,
  userSutikimasNtr: state => state.userSutikimasNtr,
  savitarnaSutartis: state => state.savitarnaSutartis,
  savitarnaXid: state => state.savitarnaXid,
  userRole: state =>
    state.userRoleEnc
      ? JSON.parse(
          decrypt(state.userRoleEnc, state.access_token + state.userID)
        )
      : [],
  signNtrVadovas: state => state.signNtrVadovas,
  zinuteAktyvi: state => state.zinuteAktyvi,
  ipasasNative: state => state.ipasasNative,
}
const actions = {
  localLogin({ commit, dispatch }, { username, password }) {
    return request({
      url: '/login',
      method: 'post',
      data: {
        username,
        password,
      },
    }).then(resp => {
      commit('SET_LOGIN', resp.naudotojas)
      commit('SET_LOGIN_PROFILE', resp.naudotojas)
      commit('SET_ZINUTE_AKTYVI', resp.zinutes)
      commit('SET_USER_ROLE', resp.roles)
      commit('SET_USER_ROLE', ['RG_STSR_registrat', 'RG_NTR_registrat'])
      commit('SET_USER_ROLE', [
        'EL_FA',
        'RG_STSR_registrat',
        'RG_NTR_registrat',
        'RG_NTR_vadovas',
        'AD_administratorius',
        'DT_notaras',
        'DT_JA',
        'ntr3.reg',
        'ntr3.fa_duomenys',
        'ntr3.istorija',

        'P_S_pagal_JA',
        'P_S_pagal_FA',
        'P_S_pagal_turta',
        'P_I_pagal_ID',
        'P_IA_pagal_ID',
        'P_IT_pagal_ID',
        'P_IAT_pagal_ID',
        'P_TZ_pagal_JA',
        'P_TZ_pagal_FA',
        'P_TZ_pagal_turta',
        'P_matyti_istorija',

        'KAC_darbuotojas',

        // 'EL_JA',
        // 'EL_PAZYMA',
        // 'EL_SKLYPAS',

        // 'AR_archyvatorius',
        // 'DT_teismas',
      ])

      // commit('SET_USER_ROLE', ['RG_NTR_vadovas'])
      // commit('SET_USER_ROLE', ['SK_skaitytojas'])
      if (resp.pirmas_prisijungimas) {
        commit('SET_SAVITARNA_SUTARTIS', false)
      }
      // dispatch('keepAlive', true)
    })
  },
  ipasasLogin({ commit, dispatch }, { enc }) {
    return request({
      url: '/ipasas',
      method: 'post',
      data: {
        enc,
      },
    })
      .then(resp => {
        commit('SET_LOGIN', resp.naudotojas)
        commit('SET_LOGIN_PROFILE', resp.naudotojas)
        commit('SET_ZINUTE_AKTYVI', resp.zinutes)
        commit('SET_USER_ROLE', resp.roles)
        if (resp.pirmas_prisijungimas) {
          commit('SET_SAVITARNA_SUTARTIS', false)
        }
        dispatch('keepAlive', true)
      })
      .catch(() => {
        console.log('ipasas failed')
      })
  },
  savitarnaLogin({ commit, dispatch }, { naudotojas, roles, xid }) {
    commit('SET_LOGIN', naudotojas)
    commit('SET_LOGIN_PROFILE', naudotojas)
    commit('SET_USER_ROLE', roles)
    commit('SET_SAVITARNA_XID', xid)
    dispatch('keepAlive', true)
  },
  logout({ commit, dispatch }) {
    dispatch('keepAlive', false)
  },
  userSutikimas({ commit }, sutikimas) {
    commit('SET_USER_SUTIKIMAS', sutikimas)
  },
  userSutikimasNtr({ commit }, sutikimas) {
    commit('SET_USER_SUTIKIMAS_NTR', sutikimas)
  },
  savitarnaSutartis({ commit }, sutartis) {
    commit('SET_SAVITARNA_SUTARTIS', sutartis)
  },
  savitarnaXid({ commit }, xid) {
    commit('SET_SAVITARNA_XID', xid)
  },
  signNtrVadovas({ commit }, signNtrVadovas) {
    commit('SET_SIGN_NTR_VADOVAS', signNtrVadovas)
  },
  zinuteAktyvi({ commit }, zinuteAktyvi) {
    commit('SET_ZINUTE_AKTYVI', zinuteAktyvi)
  },
  ipasasNative({ commit }, ipasasNative) {
    commit('SET_IPASAS_NATIVE', ipasasNative)
  },
}
const mutations = {
  SET_LOGIN(state, payload) {
    state.access_token = payload.api_token
    sessionStorage.setItem('access_token', JSON.stringify(payload.api_token))
    let expires_in =
      (payload.atjungimo_laikas > 0 ? payload.atjungimo_laikas : 15) * 60000
    state.expires_in = expires_in
    sessionStorage.setItem('expires_in', JSON.stringify(expires_in))
  },
  SET_ACCESS_TOKEN(state, token) {
    state.access_token = token
    sessionStorage.setItem('access_token', JSON.stringify(token))
  },
  SET_LOGIN_PROFILE(state, payload) {
    state.avatar = payload.avatar
    state.userID = payload.snau_id
    state.username = payload.snau_vardas + ' ' + payload.snau_pavarde
    state.userKontora = payload.snau_kontora
    state.userKontoraTipas = payload.snau_kontora_tipas
    state.userSutartis = payload.snau_sutartis_nr
    state.userSutikimas = payload.snau_sutikimas_su_salygomis
    state.userSutikimasNtr = payload.snau_sutikimas_su_salygomis_ntrpaslaugos

    sessionStorage.setItem('userID', JSON.stringify(payload.snau_id))
    sessionStorage.setItem(
      'username',
      JSON.stringify(payload.snau_vardas + ' ' + payload.snau_pavarde)
    )
    sessionStorage.setItem('userKontora', JSON.stringify(payload.snau_kontora))
    sessionStorage.setItem(
      'userKontoraTipas',
      JSON.stringify(payload.snau_kontora_tipas)
    )
    sessionStorage.setItem(
      'userSutartis',
      JSON.stringify(payload.snau_sutartis_nr)
    )
    sessionStorage.setItem(
      'userSutikimas',
      JSON.stringify(payload.snau_sutikimas_su_salygomis)
    )
    sessionStorage.setItem(
      'userSutikimasNtr',
      JSON.stringify(payload.snau_sutikimas_su_salygomis_ntrpaslaugos)
    )
  },
  SET_USER_SUTIKIMAS(state, payload) {
    state.userSutikimas = payload
    sessionStorage.setItem('userSutikimas', JSON.stringify(payload))
  },
  SET_USER_SUTIKIMAS_NTR(state, payload) {
    state.userSutikimasNtr = payload
    sessionStorage.setItem('userSutikimasNtr', JSON.stringify(payload))
  },
  SET_USER_ROLE(state, payload) {
    state.userRoleEnc = encrypt(
      JSON.stringify(payload),
      state.access_token + state.userID
    )
  },
  SET_SAVITARNA_SUTARTIS(state, payload) {
    state.savitarnaSutartis = payload
    sessionStorage.setItem('savitarnaSutartis', JSON.stringify(payload))
  },
  SET_SAVITARNA_XID(state, payload) {
    state.savitarnaXid = payload
    sessionStorage.setItem('savitarnaXid', JSON.stringify(payload))
  },
  SET_SIGN_NTR_VADOVAS(state, payload) {
    state.signNtrVadovas = payload
    sessionStorage.setItem('signNtrVadovas', JSON.stringify(payload))
  },
  SET_ZINUTE_AKTYVI(state, payload) {
    state.zinuteAktyvi = payload
    sessionStorage.setItem('zinuteAktyvi', JSON.stringify(payload))
  },
  SET_IPASAS_NATIVE(state, payload) {
    state.ipasasNative = payload
    sessionStorage.setItem('ipasasNative', JSON.stringify(payload))
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
